import { render, staticRenderFns } from "./query.vue?vue&type=template&id=14faf1c3&scoped=true"
import script from "./query.vue?vue&type=script&lang=ts"
export * from "./query.vue?vue&type=script&lang=ts"
import style0 from "./query.vue?vue&type=style&index=0&id=14faf1c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14faf1c3",
  null
  
)

export default component.exports